require("jquery")
require("@rails/ujs").start()
require("turbolinks").start()
require("./channels")

window.getRandomArbitrary = function (min, max) {
    return Math.random() * (max - min) + min;
}
